module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "mine-box-title"
  }, [_vm._v("资料修改")]), _vm._v(" "), _c('div', {
    staticClass: "mine-li"
  }, [_c('div', {
    staticClass: "updatalinfo-row-title"
  }, [_vm._v("基本信息")]), _vm._v(" "), _c('div', {
    staticClass: "flex-start"
  }, [_c('div', {
    staticClass: "info-row-title"
  }, [_vm._v("用户名:")]), _vm._v(" "), _c('div', {
    staticClass: "info-row-desc"
  }, [_vm._v(_vm._s(_vm.formData.name))])]), _vm._v(" "), _c('div', {
    staticClass: "flex-start"
  }, [_c('div', {
    staticClass: "info-row-title"
  }, [_vm._v("注册时间:")]), _vm._v(" "), _c('div', {
    staticClass: "info-row-desc"
  }, [_vm._v(_vm._s(_vm._f("timeFormatSimple")(_vm.formData.create_time)))])])]), _vm._v(" "), _c('div', {
    staticClass: "mine-li"
  }, [_c('div', {
    staticClass: "updatalinfo-row-title"
  }, [_vm._v("资料修改")]), _vm._v(" "), _c('div', {
    staticClass: "flex-between",
    staticStyle: {
      "padding": "20px 0",
      "border-bottom": "1px solid rgba(0, 0, 0, 0.06)"
    }
  }, [_c('div', {
    staticClass: "flex-start"
  }, [_c('div', {
    staticClass: "info-row-title"
  }, [_vm._v("用户名")]), _vm._v(" "), _c('div', {
    staticClass: "info-row-desc"
  }, [_vm._v(_vm._s(_vm.formData.name))])]), _vm._v(" "), _c('div', {
    staticClass: "flex-start"
  }, [_c('div', {
    staticClass: "eidt-btn",
    on: {
      "click": function($event) {
        return _vm.onMineInfoEdit('/user-name')
      }
    }
  }, [_vm._v("修改")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-between",
    staticStyle: {
      "padding": "20px 0",
      "border-bottom": "1px solid rgba(0, 0, 0, 0.06)"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "flex-start"
  }, [_c('div', {
    staticClass: "tishi"
  }, [_vm._v("安全性高的密码可以使帐号更安全。建议您定期更换密码")]), _vm._v(" "), _c('div', {
    staticClass: "eidt-btn",
    on: {
      "click": function($event) {
        return _vm.onMineInfoEdit('/user-password')
      }
    }
  }, [_vm._v("修改")])])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "flex-between",
    staticStyle: {
      "padding": "20px 0",
      "border-bottom": "1px solid rgba(0, 0, 0, 0.06)"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "flex-start"
  }, [_c('div', {
    staticClass: "tishi"
  }), _vm._v(" "), _c('div', {
    staticClass: "eidt-btn",
    on: {
      "click": function($event) {
        return _vm.onMineInfoEdit('/pay-password')
      }
    }
  }, [_vm._v("修改")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-between",
    staticStyle: {
      "padding": "20px 0"
    }
  }, [_c('div', {
    staticClass: "flex-start"
  }, [_c('div', {
    staticClass: "info-row-title"
  }, [_vm._v("绑定手机")]), _vm._v(" "), _c('div', {
    staticClass: "info-row-desc"
  }, [_vm._v(_vm._s(_vm.formData.phone))])]), _vm._v(" "), _c('div', {
    staticClass: "flex-start"
  }, [_c('div', {
    staticClass: "tishi"
  }, [_vm._v("您的手机为安全手机，可以用于登录系统，也可以找回密码")]), _vm._v(" "), _c('div', {
    staticClass: "eidt-btn",
    on: {
      "click": function($event) {
        return _vm.onMineInfoEdit('/set-phone')
      }
    }
  }, [_vm._v("修改")])])])]), _vm._v(" "), _c('div', {
    staticClass: "mine-li"
  }, [_c('div', {
    staticClass: "updatalinfo-row-title"
  }, [_vm._v("我的功能")]), _vm._v(" "), _c('div', {
    staticClass: "func-row-box"
  }, _vm._l((_vm.funcList), function(item) {
    return _c('div', {
      key: item.key,
      staticClass: "func-row-li",
      on: {
        "click": function($event) {
          return _vm.toFunc(item)
        }
      }
    }, [_c('div', {
      staticClass: "func-row-img"
    }, [_c('img', {
      attrs: {
        "src": item.pic,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "func-row-tip",
      domProps: {
        "innerHTML": _vm._s(item.name)
      }
    })])
  }), 0)]), _vm._v(" "), _c('div', [(false) ? _c('el-form', {
    ref: "ruleForm",
    attrs: {
      "label-width": "108px",
      "model": _vm.formData,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户名",
      "prop": "username"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入用户名",
      "clearable": ""
    },
    model: {
      value: (_vm.formData.username),
      callback: function($$v) {
        _vm.$set(_vm.formData, "username", $$v)
      },
      expression: "formData.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "密码",
      "prop": "pass"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "type": "password",
      "autocomplete": "off",
      "placeholder": "请输入密码",
      "clearable": ""
    },
    model: {
      value: (_vm.formData.pass),
      callback: function($$v) {
        _vm.$set(_vm.formData, "pass", $$v)
      },
      expression: "formData.pass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "重复密码",
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "type": "password",
      "autocomplete": "off",
      "placeholder": "请输入密码",
      "clearable": ""
    },
    model: {
      value: (_vm.formData.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.formData, "checkPass", $$v)
      },
      expression: "formData.checkPass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号",
      "prop": "phone"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "placeholder": "请输入中国大陆手机号",
      "clearable": ""
    },
    model: {
      value: (_vm.formData.phone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phone", _vm._n($$v))
      },
      expression: "formData.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "验证码",
      "prop": "code"
    }
  }, [_c('el-input', {
    staticClass: "inputidecode",
    staticStyle: {
      "width": "150px",
      "height": "34px"
    },
    attrs: {
      "placeholder": "请输入验证码",
      "clearable": ""
    },
    model: {
      value: (_vm.formData.code),
      callback: function($$v) {
        _vm.$set(_vm.formData, "code", _vm._n($$v))
      },
      expression: "formData.code"
    }
  }), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.getidecodeFun
    }
  }, [_vm._v(_vm._s(_vm.getidecodeData))])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-foot-bar fixed-footer-bar"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.resetForm('ruleForm')
      }
    }
  }, [_vm._v("还原")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.centerDialogVisible,
      "width": "30%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.centerDialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v("正在建设中~")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.centerDialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.centerDialogVisible = false
      }
    }
  }, [_vm._v("确 定")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-start"
  }, [_c('div', {
    staticClass: "info-row-title"
  }, [_vm._v("登录密码")]), _vm._v(" "), _c('div', {
    staticClass: "info-row-desc"
  }, [_vm._v("******")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-start"
  }, [_c('div', {
    staticClass: "info-row-title"
  }, [_vm._v("支付密码")]), _vm._v(" "), _c('div', {
    staticClass: "info-row-desc"
  }, [_vm._v("******")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-367cf75e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/user/mine/UpdataInfo.vue
// module id = 1450
// module chunks = 0